import StatusSummary from './status_summary'
import connect from './connect'

export default connect(StatusSummary)
